module.exports = __webpack_public_path__ + "static/media/game.107d31e8.png";